import bnbChain from "../../../../assets/membersLogos/bnbChain.png";
import Coinmarketcap from "../../../../assets/membersLogos/CoinMarketCap.png";
import YZILabs from "../../../../assets/membersLogos/yZiLabs.png";
import AGNTHubIcon from "../../../../assets/svgComponents/AGNTGubIcon";
import React from "react";
import {
  buttonGradient,
  buttonShadow,
  customShadow,
  mainCardGradient,
  mainIconGradient,
} from "./utils/classes";
import LocationIcon from "assets/images/cardPage/LocationIcon";

interface AcceleratedByProps {
  mvbLogoSrc?: string;
  bnbChainLogoSrc?: string;
  coinMarketCapLogoSrc?: string;
  yziLabsLogoSrc?: string;
}

export const AcceleratedByCard: React.FC<AcceleratedByProps> = () => {
  return (
    <div className="flex flex-col gap-[0.83vw] max-lg:gap-[2.1vw]">
      {" "}
      <div className="relative z-10">
        <div
          className={`w-full max-w-[43.3vw] pl-[1vw] flex items-center justify-start border-none ${customShadow} ${mainCardGradient} 
      
            max-lg:w-full max-lg:max-w-full 
            max-lg:bg-[#f3f2f7] 

            !h-[5vw] gap-[1vw] text-[1.6vw] bg-[#f3f2f7] rounded-[1.94vw]
       
            max-lg:!h-[17vw] 
            max-lg:pl-[4.26vw] max-lg:pr-[4.26 vw]
            max-lg:gap-[3.2vw] 
             max-lg:text-[4.26vw] 
            max-lg:rounded-[7.4vw]`}
        >
          <LocationIcon className="h-[2.6vw] max-lg:h-[10vw] w-auto" />
          <div className="max-lg:text-[4.8vw] text-[1.6vw] font-luxora-regular"> Works all around the world</div>
        </div>
      </div>
      <div className="relative z-10 flex flex-col justify-center ">
        <a
          href="https://x.com/agnt_hub/status/1948742398177128788"
          target="_blank"
          rel="noreferrer"
          className={`w-full max-w-[43.5vw] max-lg:max-w-full bg-[#f3f2f7] rounded-[1.94vw] max-lg:rounded-[5.33vw]
          border-none ${customShadow} ${mainCardGradient}`}
        >
          <div className="flex items-start gap-[1.1vw] p-[1.11vw] max-lg:gap-[3.2vw] max-lg:p-[4.27vw]">
            <div
              className={`w-[3.68vw] h-[3.68vw] max-lg:w-[8.53vw] max-lg:h-[8.53vw] ${customShadow} rounded-full 
            max-lg:rounded-full flex items-center justify-center ${mainIconGradient}`}
            >
              <AGNTHubIcon className="w-[3.68vw] h-[3.68vw] max-lg:w-[8.53vw] max-lg:h-[8.53vw] pointer-events-none" />
            </div>

            <div className="flex flex-col items-start gap-[0.83vw] max-lg:gap-[2.13vw] flex-1">
              <p className="text-black font-luxora-regular text-[1.67vw] leading-[110%] max-lg:text-[4.8vw]">
                MVB10 member, accelerated by
              </p>

              <div className="flex flex-wrap gap-[0.55vw] max-lg:gap-[1.06vw]">
                <AcceleratorButton
                  label="BNB CHAIN"
                  responsiveHeight="h-[1.7vw] max-lg:h-[4.45vw]"
                  textColor="text-orange-500"
                  logoSrc={bnbChain}
                  padding="py-[0.9vw] px-[1.1vw] max-lg:py-[2.13vw] max-lg:px-[3.2vw]"
                />
                <AcceleratorButton
                  label="CoinMarketCap"
                  responsiveHeight="h-[2.2vw] max-lg:h-[5.86vw]"
                  textColor="text-gray-700"
                  logoSrc={Coinmarketcap}
                  padding="py-[0.6vw] px-[1.15vw] max-lg:py-[1.46vw] max-lg:px-[3.2vw]"
                />
                <AcceleratorButton
                  label="YZiLabs"
                  responsiveHeight="h-[1.9vw] max-lg:h-[5.55vw]"
                  textColor="text-yellow-500"
                  logoSrc={YZILabs}
                  padding="py-[0.9vw] px-[1.1vw] max-lg:py-[1.73vw] max-lg:px-[3.2vw]"
                />
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

interface AcceleratorButtonProps {
  label: string;
  responsiveHeight: string;
  textColor: string;
  logoSrc?: string;
  padding?: string;
}

const AcceleratorButton: React.FC<AcceleratorButtonProps> = ({
  label,
  responsiveHeight,
  textColor,
  logoSrc,
  padding,
}) => (
  <div className={buttonGradient}>
    <button
      className={`
      flex items-center justify-center space-x-[0.27vw] py-[0.55vw] px-[1.15vw] max-lg:space-x-[1.33vw] max-lg:py-[2.13vw] max-lg:px-[3.2vw] h-[3.47vw] max-lg:h-[8.8vw]
      rounded-[6.94vw] max-lg:rounded-[26.67vw] font-medium text-[0.83vw] max-lg:text-[3.2vw] leading-[1.11vw] max-lg:leading-[4.27vw] bg-[#E9EBF3]
      ${buttonShadow} 
      ${textColor}
      ${padding}
    `}
    >
      {responsiveHeight && (
        <img src={logoSrc} alt={`${label} Logo`} className={responsiveHeight} />
      )}
    </button>
  </div>
);
